<template>
  <b-modal :active.sync="isModalActive" has-modal-card>
    <div class="modal-card">
      <header class="modal-card-head">
        <h1 class="is-title-header modal-card-title">{{ action }} Product</h1>
      </header>
      <section class="modal-card-body">
        <div class="columns">
          <div class="column">
            <b-field label="Product Name">
              <b-input
                expanded
                name="product_name"
                v-model="form.product_name"
                :disabled="viewOnly"
                required
              ></b-input>
            </b-field>
            <b-field label="Product Number">
              <b-input
                expanded
                name="product_number"
                v-model="form.product_number"
                :disabled="viewOnly"
                required
              ></b-input>
            </b-field>
            <b-field label="Product Barcode (EAN)">
              <b-input
                expanded
                name="product_barcode"
                v-model="form.product_barcode"
                :disabled="viewOnly"
                required
              ></b-input>
            </b-field>
          </div>
        </div>
      </section>
      <footer class="modal-card-foot">
        <b-button slot="right" type="is-normal" @click="cancel">
          Cancel
        </b-button>
        <b-button
          slot="right"
          native-type="submit"
          type="is-primary"
          v-on:click="validateBeforeSubmit"
          v-if="!viewOnly"
        >
          <span>{{ action }}</span>
        </b-button>
      </footer>
    </div>
  </b-modal>
</template>

<script>
import UtilityMixin from "@/mixins/UtilityMixin";
import scopeMixin from "@/mixins/scopeMixin";
import RAMSurveyService from "@/services/RAMSurveyService";
// @group Dashboard
export default {
  name: "AddProduct",
  mixins: [UtilityMixin, scopeMixin],
  props: {
    action: {
      type: String,
      default: "Inserts"
    },
    viewOnly: {
      type: Boolean,
      default: true
    },
    customerId: {
      type: Number,
      default: -1
    },
    isActive: {
      type: Boolean,
      default: false
    },
    form: {
      type: Object,
      default: () => {
        return {
          id: "",
          product_name: "",
          product_number: "",
          product_barcode: ""
        };
      }
    },
    isDelete: {
      type: Boolean,
      default: true
    }
  },

  data() {
    return {
      customer: this.customerId,
      isModalActive: false,
      loading: "",
      surveyService: new RAMSurveyService()
    };
  },
  methods: {
    cancel() {
      this.$emit("cancel");
    },
    validateBeforeSubmit() {
      if (
        !this.form.product_name ||
        !this.form.product_number ||
        !this.form.product_barcode
      ) {
        this.$buefy.dialog.alert({
          title: "Error",
          message: "Please fill in all required fields.",
          type: "is-danger",
          ariaRole: "alertdialog",
          ariaModal: true
        });
        return;
      }
      this.submit();
    },
    submit() {
      if (this.action == "Add") {
        this.surveyService
          .createSurveyProduct(this.customer, this.form)
          .subscribe(response => {
            this.$buefy.dialog.alert({
              title: "Success",
              message: "New Product is Added!"
            });
            this.$emit("confirm", response);
          }, this.handleApiError);
      } else if (this.action == "Update") {
        this.surveyService
          .updateSurveyProduct(this.customer, this.form)
          .subscribe(response => {
            this.$buefy.dialog.alert({
              title: "Success",
              message: "Product is Updated!"
            });
            this.$emit("confirm", response);
          }, this.handleApiError);
      }
    },
    handleApiError(reason) {
      let errorMessage = reason.response.data["detail"];

      if (errorMessage == null || errorMessage == undefined) {
        errorMessage = "Invalid input";
      }
      this.$buefy.dialog.alert({
        title: "Error",
        message: errorMessage,
        type: "is-danger",
        ariaRole: "alertdialog",
        ariaModal: true
      });
      this.isDataLoading = false;
    }
  },
  watch: {
    isActive(newValue) {
      this.isModalActive = newValue;
    },
    customerId(newValue) {
      this.customer = newValue;
    },
    isModalActive(newValue) {
      if (!newValue) {
        this.cancel();
      }
    }
  }
};
</script>
